// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xJ4k","comment":"styles_comment__26ox0"};